/** Which empty-state copy to show in the Today panel (open list is already empty). */
export const TodayPanelEmptyVariant = {
  NEVER_HAD_TASKS: 'neverHadTasks',
  NOTHING_PLANNED: 'nothingPlanned',
  ALL_DONE: 'allDone',
};

/**
 * @param {{ allTasksCount: number; completedTodayCount: number }} params
 * `allTasksCount` = user's tasks in Firestore snapshot (cheapest "ever had a task" signal).
 */
export function resolveTodayPanelEmptyVariant({
  allTasksCount,
  completedTodayCount,
}) {
  if (allTasksCount === 0) {
    return TodayPanelEmptyVariant.NEVER_HAD_TASKS;
  }
  if (completedTodayCount === 0) {
    return TodayPanelEmptyVariant.NOTHING_PLANNED;
  }
  return TodayPanelEmptyVariant.ALL_DONE;
}

export function getTodayPanelEmptyTextKey(variant) {
  switch (variant) {
    case TodayPanelEmptyVariant.NEVER_HAD_TASKS:
      return 'todayviewcontent.todayNoTasksEver';
    case TodayPanelEmptyVariant.NOTHING_PLANNED:
      return 'todayviewcontent.todayNothingPlanned';
    case TodayPanelEmptyVariant.ALL_DONE:
      return 'todayviewcontent.todayEmpty';
    default:
      return 'todayviewcontent.todayEmpty';
  }
}
